import type { ReelsetComponent, SlotGameStore, SymbolView } from "@gamzix/slot_core";
import { CONST } from "../../../src/const";

class MoveSymbolsComponent extends Game.src.component.BaseComponent {
    protected TIME_MOVE_SYMBOL = 500;
    protected TIME_MOVE_ARROW = 700;
    protected TIME_DELAY_REEL = 100;

    static events = {
        ANIM_MOVE_SYMBOL_FINISH: "MoveSymbolsComponent.ANIM_MOVE_SYMBOL_FINISH",
    }

    async playMoveAnim(symbolData, targetCoin) {
        const from = { x: symbolData.reelId, y: symbolData.rowId };
        const to = { x: targetCoin.reelId, y: targetCoin.rowId };

        const fromSymbol = this.reelset.getSymbol(from.x, from.y);

        const copyFromData = JSON.parse(JSON.stringify(this.store.gameData.reels[from.x][from.y]));
        const toSymbol = this.reelset.getSymbol(to.x, to.y);

        //@ts-ignore
        const symbol = new ReelsetComponent.src.SymbolView();
        symbol.reelId = from.x;
        symbol.rowId = from.y;
        symbol.id = symbolData.symbol;
        symbol.playStatic();

        //@ts-ignore
        const symbolView = symbol.view;
        symbolView.visible = false;
        this.view.addChild(symbol);

        await game.utils.GameUtils.playMoveAnimation(symbolView, {
            fromElement: fromSymbol,
            toElement: toSymbol,
            time: this.TIME_MOVE_SYMBOL,
            ease: "bounceOut",
            onStart: () => {
                // на пустое поле
                fromSymbol.id = "EMPTY";
                fromSymbol.playIdle();

                symbolView.visible = true;
                //@ts-ignore
                symbolView.parentGroup = null;
            },
            onFinish: () => {
                game.emit(MoveSymbolsComponent.events.ANIM_MOVE_SYMBOL_FINISH);
            },
        })

        toSymbol.id = copyFromData.symbol;

        // for correct textOverlay
        this.store.gameData.reels[from.x][from.y] = { symbol: '1' }; //random symbol on FROM place
        this.store.gameData.reels[to.x][to.y] = copyFromData;
        toSymbol.reelId = to.x;
        toSymbol.rowId = to.y;

        toSymbol.playIdle();

        // await game.utils.delay(300);
        game.utils.PIXIUtils.remove(symbol);
    }

    isNeedMove() {
        let isNeedMoveArr = [];

        this.store.gameData.holdPositions.forEach((holdPos, i) => {
            const { from, to, symbol} = holdPos;
            const [fromX, fromY] = from;
            const [toX, toY] = to;

            let isNeedMove = true;
            if (fromX === toX && fromY === toY) {
                isNeedMove = false;
            }

            isNeedMoveArr.push(isNeedMove);
        });

        return isNeedMoveArr.some((el) => el === true);
    }

    async playMoveSymbols() {
        if (this.isNeedMove()) {
            await this.reelset.resetAllHoldPositions();
            const promises = [];

            // start align Y
            this.store.gameData.holdPositions.forEach((holdPos, i) => {
                const { from, to, symbol} = holdPos;
                const [fromX, fromY] = from;
                const [toX, toY] = to;

                let symbolData = {
                    symbol,
                    reelId: fromX,
                    rowId: fromY,
                };

                const targetCoin = {
                    reelId: fromX,
                    rowId: toY
                };

                promises.push(this.playMoveAnim(symbolData, targetCoin));
            });

            await  Promise.all(promises);
            await game.utils.delay(500);

            // start align X
            this.store.gameData.holdPositions.forEach((holdPos, i) => {
                const { from, to, symbol} = holdPos;
                const [fromX, fromY] = from;
                const [toX, toY] = to;

                let symbolData = {
                    symbol,
                    reelId: fromX,
                    rowId: toY,
                };

                const targetCoin = {
                    reelId: toX,
                    rowId: toY
                };

                promises.push(this.playMoveAnim(symbolData, targetCoin));
            });

            await  Promise.all(promises);
        }
    }

    get reelset(): ReelsetComponent {
        return <any>game.component.reelset;
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    getFSMHandlers() {
        return {
            IDLE: {
                bonusAlign: {
                    on: async () => {
                        await this.playMoveSymbols();

                        //@ts-ignore
                        this.reelset.showBonusCluster();
                        await game.utils.delay(500);
                    },
                    check: () => this.store.gameData.bonusGame.count === 1
                },
            },
        }
    }
}

// @ts-ignore
Game.src.component.MoveSymbolsComponent = MoveSymbolsComponent;
